<tvsub-step-container (action)="onAction($event)" [step]="step" [steps]="STEPS" [subsidyType]="type()">
	@if (form) {
		<form [formGroup]="form" class="u-width--md">
			<ng-content></ng-content>

			<tvcore-checkbox [control]="form.get('accept')" class="u-m-top--sm" name="accept">Ik heb bovenstaande verbintenissen gelezen en ga ermee akkoord.</tvcore-checkbox>

			@if (showErrors && form.get('accept').errors) {
				<p class="u-text--sm u-text--error">Dit is verplicht.</p>
			}
		</form>
	}
</tvsub-step-container>
